import styled from '@emotion/styled';
import { CloseIcon } from 'src/assets/icons/CloseIcon';

export const WrongIconWrapper = styled(CloseIcon, { label: 'WrongIconWrapper' })`
    margin-left: 10px;
    margin: 10px;
    cursor: pointer;
    position: absolute;
    right: 0;
    width: 15px;
`;

export const XmlDetailsWrapper = styled('div', { label: 'XmlDetailsWrapper' })`
    background-color: white;
    height: calc(100% - 80px);
    margin: 60px 20px 20px 20px;
    width: calc(100% - 40px);
`;

export const XmlDetailsSection = styled('div', { label: 'XmlDetailsSection' })`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: scroll;
    padding: 20px;
    white-space: normal;
`;

export const XmlDetailsTitle = styled('h3', { label: 'XmlDetailsTitle' })`
    display: block;
    width: 50%;
`;
